import Vue from 'vue';
import COS from 'cos-js-sdk-v5';
import ajax from './ajax';
import { getQueryVariable, getShareCode } from '@/utils';
import { API } from './api';
import { COS_BIZ_TYPE } from '@/constants';

const COSURL = API.DescribeStorageCredential;

export const cos = {
    cosInstance: null,
    cosTimeout: 5000,
    config: {
        Bucket: '',
        Region: '',
        Prefix: '',
        botBizId: '',
        bizType: ''
    },
    getAuthorization (options, callback) {
        const DefaultCosReqData =
      !this.config.botBizId &&
      this.config.bizType === COS_BIZ_TYPE.AVATAR_UPLOAD
          ? {
              bot_biz_id: '0'
          }
          : {};
        ajax.post(COSURL, DefaultCosReqData).then((res) => {
            const credentials = res.credentials;
            /* eslint-disable */
      callback({
        TmpSecretId: credentials.tmp_secret_id,
        TmpSecretKey: credentials.tmp_secret_key,
        SecurityToken: credentials.token,
        StartTime: res.start_time,
        ExpiredTime: res.expired_time,
      });
    });
  },
  async getCos(bizType, isPublic = false, fileType = undefined, ignoreTypeKey) {
    console.log("getCos");
    const sharecode = getShareCode();
    const botBizId = sharecode ? window.localStorage.getItem(`bot_biz_id_im_${sharecode}`) :
      window.localStorage.getItem("bot_biz_id_im") ||
      getQueryVariable("bot_biz_id");
    /**
     * 后台对无应用id的场景加了特殊逻辑，使用id 0请求可以获取临时token
     * 但是返回的file_path为空，不可使用，因此限定场景为头像上传，使用public path
     */
    const DefaultCosReqData ={
      botBizId,
      isPublic,
    };
    // 获取下载、预览链接时，需要过滤fileType和typeKey，避免权限问题
    if(fileType) {
      DefaultCosReqData.fileType = fileType;
    }
    if(!ignoreTypeKey) {
      DefaultCosReqData.typeKey = 'realtime';
    }
    try {
      // 直接获取cos信息，初始化cos实例
      const tempConfig = await ajax.post(COSURL, DefaultCosReqData);
      const {
        bucket,
        region,
        file_path,
        upload_path,
        image_path,
        credentials,
        start_time,
        expired_time,
      } = tempConfig;
      this.config.Bucket = bucket;
      this.config.Region = region;
      this.config.Prefix = upload_path;
      this.config.botBizId = botBizId;
      this.config.bizType = bizType;
      //   }
      this.cosInstance = new COS({
        SecretId: credentials.tmp_secret_id,
        SecretKey: credentials.tmp_secret_key,
        SecurityToken: credentials.token,
        StartTime: start_time,
        ExpiredTime: expired_time,
      });
      return this.cosInstance;
    } catch (e) {
      Vue.prototype.$message.error("获取COS信息失败");
      Vue.prototype.$message.error("下载初始化失败");
      console.log("下载初始化失败error", e);
    }
  },
  apiParse(isPublic, bizType, file, onProgress, onUploaded, ignoreTypeKey) {
    const nameArr = (file.name || file.saveName).split(".");
    return new Promise(resolve => {
      this.getCos(bizType, isPublic, nameArr[nameArr.length - 1], ignoreTypeKey).then(
        (instance) => {
          if (!instance) {
            reject("cos instance error");
          }
          const cos_url = this.config.Prefix;
          const cos_bucket = this.config.Bucket;
          instance.uploadFile(
            {
              Bucket: this.config.Bucket,
              Region: this.config.Region,
              Key: cos_url,
              Body: file.data,
              SliceSize: 1024 * 1024 * 20,
              onTaskReady: function(taskId) {
                console.log("onProgress data onTaskReady", file);
                onProgress &&
                  onProgress(file.saveName, { ...file, process: 0 });
              },
              onProgress: function(processData) {
                console.log("onProgress data onProgress", file);

                console.log(processData.percent);
                onProgress &&
                  onProgress(file.saveName, {
                    ...file,
                    process: processData.percent - 0.01,
                    cos_url,
                  });
              },
              onFileFinish: function(err, data, options) {
                console.log("onProgress data onFileFinish", file);

                if (err) {
                  onProgress &&
                    onProgress(file.saveName, {
                      ...file,
                      cos_url,
                      process: -1,
                    });
                } else {
                  onProgress &&
                    onProgress(file.saveName, {
                      ...file,
                      cos_url,
                      process: 1 - 0.01,
                    });
                  setTimeout(() => {
                    console.log("onProgress data", data);
                    onProgress &&
                      onProgress(file.saveName, {
                        ...file,
                        process: 1,
                        cos_bucket,
                        e_tag: data.ETag,
                        cos_url,
                        cos_hash:
                          (data.headers &&
                            data.headers["x-cos-hash-crc64ecma"]) ||
                          data.ETag,
                        size: file.data.size || 0,
                        url: `${window.location.protocol}//${data.Location}`,
                      });
                  }, 100);
                }
              },
            },
            function(err, data) {
              if (err) {
                Vue.prototype.$message.error("文件上传失败");
                onProgress && onProgress(file.saveName, -1);
                reject(err);
                return;
              }
              // 文件上传成功
              onUploaded &&
                onUploaded(file.saveName, {
                  ...file,
                  e_tag: data.ETag,
                  cos_url,
                  cos_hash:
                    (data.headers && data.headers["x-cos-hash-crc64ecma"]) ||
                    data.ETag,
                  size: `${file.data.size || 0}`,
                  url: `${window.location.protocol}//${data.Location}`,
                });
              console.log("resolve");
              resolve({
                ...file,
                saveName: file.saveName,
                e_tag: data.ETag,
                cos_url,
                cos_hash:
                  (data.headers && data.headers["x-cos-hash-crc64ecma"]) ||
                  data.ETag,
                size: file.data.size || 0,
                url: `${window.location.protocol}//${data.Location}`,
              });
            }
          );
        }
      );
    });
  },
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  },
  async upload(isPublic, bizType, files, onProgress, onUploaded, ignoreTypeKey) {
    // console.log("upload", files);
    const paramsList = files
    const batchSize = 1
    let allResults = [];
    console.log('【uploaddddddddddddddddddddddd】2222222222 cos', files, paramsList);
    // console.log('【uploaddddddddddddddddddddddd】22222222221111111111 cos', isPublic, bizType, files, onProgress, onUploaded, ignoreTypeKey);

    for (let i = 0; i < paramsList.length; i += batchSize) {
      const batch = paramsList.slice(i, i + batchSize);
      // 并发执行本组请求
      const promises = batch.map(file => {
        return this.apiParse(isPublic, bizType, file, onProgress, onUploaded, ignoreTypeKey)
      });
      const results = await Promise.all(promises);
      allResults = [...allResults, ...results];
      console.log('本组完成:', results);
      if (i + batchSize < paramsList.length) {
        await this.sleep(1000);
      }
    }
    // console.log('全部完成', allResults);
    // 兼容单个上传的逻辑
    return allResults.length === 1 ? allResults[0] : allResults;
  },


    // return new Promise((resolve, reject) => {
    //   files.forEach((file) => {
        
    //     const nameArr = (file.name || file.saveName).split(".");
       
    //   });
    // });

  async upload1(isPublic, bizType, files, onProgress, onUploaded, ignoreTypeKey) {
    // console.log("upload", files);
    console.log('【uploaddddddddddddddddddddddd】2222222222 cos', files);

    return new Promise((resolve, reject) => {
      files.forEach((file) => {
        const nameArr = (file.name || file.saveName).split(".");
        this.getCos(bizType, isPublic, nameArr[nameArr.length - 1], ignoreTypeKey).then(
          (instance) => {
            if (!instance) {
              reject("cos instance error");
            }
            const cos_url = this.config.Prefix;
            const cos_bucket = this.config.Bucket;
            instance.uploadFile(
              {
                Bucket: this.config.Bucket,
                Region: this.config.Region,
                Key: cos_url,
                Body: file.data,
                SliceSize: 1024 * 1024 * 20,
                onTaskReady: function(taskId) {
                  onProgress &&
                    onProgress(file.saveName, { ...file, process: 0 });
                },
                onProgress: function(processData) {
                  console.log(processData.percent);
                  onProgress &&
                    onProgress(file.saveName, {
                      ...file,
                      process: processData.percent - 0.01,
                      cos_url,
                    });
                },
                onFileFinish: function(err, data, options) {
                  if (err) {
                    onProgress &&
                      onProgress(file.saveName, {
                        ...file,
                        cos_url,
                        process: -1,
                      });
                  } else {
                    onProgress &&
                      onProgress(file.saveName, {
                        ...file,
                        cos_url,
                        process: 1 - 0.01,
                      });
                    setTimeout(() => {
                      console.log("onProgress data", data);
                      onProgress &&
                        onProgress(file.saveName, {
                          ...file,
                          process: 1,
                          cos_bucket,
                          e_tag: data.ETag,
                          cos_url,
                          cos_hash:
                            (data.headers &&
                              data.headers["x-cos-hash-crc64ecma"]) ||
                            data.ETag,
                          size: file.data.size || 0,
                          url: `${window.location.protocol}//${data.Location}`,
                        });
                    }, 100);
                  }
                },
              },
              function(err, data) {
                if (err) {
                  Vue.prototype.$message.error("文件上传失败");
                  onProgress && onProgress(file.saveName, -1);
                  reject(err);
                  return;
                }
                // 文件上传成功
                onUploaded &&
                  onUploaded(file.saveName, {
                    ...file,
                    e_tag: data.ETag,
                    cos_url,
                    cos_hash:
                      (data.headers && data.headers["x-cos-hash-crc64ecma"]) ||
                      data.ETag,
                    size: `${file.data.size || 0}`,
                    url: `${window.location.protocol}//${data.Location}`,
                  });
                console.log("resolve");
                resolve({
                  ...file,
                  saveName: file.saveName,
                  e_tag: data.ETag,
                  cos_url,
                  cos_hash:
                    (data.headers && data.headers["x-cos-hash-crc64ecma"]) ||
                    data.ETag,
                  size: file.data.size || 0,
                  url: `${window.location.protocol}//${data.Location}`,
                });
              }
            );
          }
        );
      });
    });
  },
  async getDocHtmlUrl(bizType, file) {
    try {
      const nameArr = (file.name || file.saveName).split(".");
      const fileType = nameArr[nameArr.length - 1];
      const cos = await this.getCos(bizType, false, null, true);
      
      const data = await new Promise((resolve, reject) => {
        cos.getObjectUrl({
          Bucket: this.config.Bucket,
          Region: this.config.Region,
          Key: file.cos_url,
          Query: {
            'ci-process': 'doc-preview', /* 必须，数据万象处理能力，文档预览固定为 doc-preview */
            dstType: 'html',
          },
        }, function(err, data) {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        });
      });
      return data.Url;
    } catch (err) {
      console.error('Failed to get document HTML URL:', err);
      throw err;
    }
  },
  async getImagelUrl1(bizType, file) {
    try {
      const cos = await this.getCos(bizType, false, null, false);
      const data = await new Promise((resolve, reject) => {
        cos.getObjectUrl({
          Bucket: this.config.Bucket,
          Region: this.config.Region,
          Key: file.cos_url,
          Sign: true,
          Method: 'GET',
          Expires: 7776000 // 三个月 
        }, function(err, data) {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        });
      });
      console.log('ispublic...........image', file, data.Url)
      return data.Url;
    } catch (err) {
      console.error('Failed to get document HTML URL:', err);
      throw err;
    }
  },

  async getImagelUrl(bizType, file) {
    try {
      // const cos = await this.getCos(bizType, false, null, false);
      // const data = await new Promise((resolve, reject) => {
      //   cos.getObjectUrl({
      //     Bucket: this.config.Bucket,
      //     Region: this.config.Region,
      //     Key: file.cos_url,
      //     Sign: true,
      //     Method: 'GET',
      //     Expires: 7776000 // 三个月 
      //   }, function(err, data) {
      //     if (err) {
      //       reject(err);
      //     } else {
      //       resolve(data);
      //     }
      //   });
      // });
      const sharecode = getShareCode();
      const botBizId = sharecode ? window.localStorage.getItem(`bot_biz_id_im_${sharecode}`) :
      window.localStorage.getItem("bot_biz_id_im") ||
      getQueryVariable("bot_biz_id");
      const tempConfig = await ajax.post(API.GetImagePreview, {
        AppBizId: botBizId,
        TypeKey: 'realtime',
        CosUrl: file.cos_url
      });

      console.log('ispublic...........image', botBizId, file, tempConfig)
      return tempConfig.url;
    } catch (err) {
      console.error('Failed to get document HTML URL:', err);
      throw err;
    }
  },

  async getDownloadUrl(bizType, file, cb, expires, ignoreTypeKey) {
    console.log('233333333333333333 agent1111111', file);

    try {
      const nameArr = (file.name || file.saveName).split(".");
      const fileType = nameArr[nameArr.length - 1];
      const instance = await this.getCos(bizType, false, null, ignoreTypeKey);
      const data = await new Promise((resolve, reject) => {
        const params = {
          Bucket: this.config.Bucket,
          Region: this.config.Region,
          Key: file.cos_url || file.upload_path,
          Sign: true,
        };
        if(expires) {
          params.Expires = expires;
        }
        console.log('233333333333333333 agent1111111 params', params);

        instance.getObjectUrl(
          params,
          function(err, data) {
            if (err) {
              reject(err);
              return;
            }
            resolve(data);
          }
        );
      });

      return data.Url +
        (data.Url.indexOf("?") > -1 ? "&" : "?") +
        "response-content-disposition=attachment&response-content-type=application%2Foctet-stream";
    } catch (err) {
      cb && cb(err);
      throw err;
    }
  },
  async download(bizType, file, cb) {
    console.log("download");
    try {
      const downloadUrl = await this.getDownloadUrl(bizType, file, cb);
      window.open(downloadUrl);
    } catch (err) {
      console.error("Download failed:", err);
    }
  },
  async getUrl(bizType, cos_url, callback) {
    console.log('getUrl');
    return new Promise((resolve, reject) => {
      this.getCos(bizType).then(instance => {
        instance.getObjectUrl(
          {
            Bucket: this.config.Bucket,
            Region: this.config.Region,
            Key: cos_url,
          },
          function (err, data) {
            if (err) {
              callback && callback("", err);
              reject(err);
              return;
            }
            var url = data.Url;
            var viewUrl =
              url +
              (url.indexOf("?") > -1 ? "&" : "?") +
              "response-content-disposition=inline";
              viewUrl = viewUrl.split("?")[0];
            callback && callback(viewUrl, "");
            resolve(viewUrl);
          }
        );
      })
    });
  },
  reNameFile(length) {
    console.log("reNameFile");
    const data = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
    ];
    let nums = "";
    for (let i = 0; i < length; i++) {
      const r = parseInt(Math.random() * 61, 10);
      nums += data[r];
    }
    console.log(
      "reNameFile",
      nums + "-" + parseInt(Math.random() * 10000000000, 10)
    );
    return nums + "-" + parseInt(Math.random() * 10000000000, 10);
  },
  async getObject(bizType, key, successCb, failCb) {
    console.log("getObject");
    // 直接获取cos信息，初始化cos实例
    const instance = await this.getCos(bizType);
    instance.getObject(
      {
        Bucket: this.config.Bucket,
        Region: this.config.Region,
        Key: key,
        onprocess: function(processData) {
          console.log(JSON.stringify(processData));
        },
      },
      function(err, data) {
        if (err) {
          Vue.prototype.$message.error("下载文件二进制流失败", err);
          failCb && failCb(err);
          return;
        }

        successCb && successCb(data.Body);
      }
    );
  },
};



// WEBPACK FOOTER //
// ./src/utils/cos.js